import React from "react";
import { Route, Redirect } from "react-router-dom";
import isLoggedIn from "../helpers/isLoggedIn";
import checkRole from "../helpers/checkRole";
import SmallNav from "../components/layouts/SmallNav";
import GloabalNavbar from "../components/layouts/GloabalNavbar";
import { useDispatch, useSelector } from "react-redux";

const AppRoute = ({ component: Component, isAuthProtected, role, ...rest }) => {
  const { isOpen } = useSelector((state) => state.design);
  let isHome = window.location.pathname === "/home";
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthProtected && !isLoggedIn()) {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }
        // if (!isAuthProtected && isLoggedIn()) {
        //   return (
        //     <Redirect to={{ pathname: "/#", state: { from: props.location } }} />
        //   );
        // }

        // check if route is restricted by role
        else if (role && !checkRole(role)) {
          // role not authorised so redirect to home page
          return <Redirect to={{ pathname: "/unauthorized" }} />;
        }

        return (
          <>
            {isAuthProtected && isLoggedIn() ? <GloabalNavbar /> : null}

            {!isHome && isAuthProtected ? <SmallNav /> : null}
            <Component {...props} />
          </>
        );
      }}
    />
  );
};

export default AppRoute;
